// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_t4y","cls2":"CiterightLanding-cls2_XJR CiterightLanding-cls1_t4y"};